import RouterUrlHelper from '../../routes/RouterUrlHelper';

const Footer = () => {
  return (
    <footer className={'bg-primary-dark py-[50px]'}>
      <div
        className={
          'container flex flex-col justify-center md:flex-row md:justify-between md:items-center'
        }
      >
        <div className={'flex flex-col justify-center items-center mb-6 md:items-start'}>
          <a
            href={RouterUrlHelper.urlMap.root.path}
            target={'_blank'}
            className={'flex justify-center'}
          >
            <img src="/PayLinker-white.svg" alt="logo" className={'w-[120px] mb-[20px]'} />
          </a>
          <p className={'text-gray-200'}>&copy; 2022 PayLinker. Усі права захищено.</p>
        </div>
        <div className={'text-gray-200 flex flex-col items-center md:items-start'}>
          <div>
            Розробка:{' '}
            <a
              href="https://instagram.com/panteleymonchuk"
              target={'_blank'}
              className={'text-primary-main'}
            >
              @panteleymonchuk
            </a>
          </div>
          <a className={'flex mt-4'} href="https://t.me/DmytroKundys" target={'_blank'}>
            Дизайн: <img src="/KUNDYS-logo.svg" alt="KUNDYS-logo" className={'ml-3 w-[60px]'} />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
